module.exports = __webpack_public_path__ + "06_2x.jpg?a09cc505864400e18782e70558ef51fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/06_2x.jpg
// module id = 17
// module chunks = 0